export default (params) => {
  const { lowerIndex, upperIndex, editor } = params;
  const {
    value: {
      document: { nodes: editorDocumentNodes },
    },
  } = editor;
  const editorDocumentNodesArray = editorDocumentNodes.toArray();
  let { ordinalNo } = params;
  editorDocumentNodesArray.slice(lowerIndex, upperIndex).forEach((orgNode) => {
    const { key: orgKey, data: orgData } = orgNode;
    const orgDataJSON = orgData.toJSON();
    editor.setNodeByKey(orgKey, {
      data: {
        ...orgDataJSON,
        Ordinal: ordinalNo,
      },
    });
    ordinalNo += 1;
  });
};
